<template>
  <div id="model">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'model'
}
</script>




// WEBPACK FOOTER //
// src/views/process/model/Model.vue